import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import { CSVLink } from 'react-csv';

const PrintCsv = props => {

    const {
        data: _data,
        selectedAmenities,
        propertyName
    } = props;


    const [shouldPrint, setShouldPrint] = useState(false);
    const [preparing, setPreparing] = useState(false);
    const [data, setData] = useState([]);
    useEffect(() => {

        if (shouldPrint) {

            setPreparing(true);
            setData(
                _data.map(item => {

                    const element = {
                        building: item.building,
                        floor: item.floor,
                        unit_type: item.unit_type
                    };
                    selectedAmenities.map(amenityName => (

                        element[amenityName] = item[amenityName]?.size
                    ));

                    element.Union = item.intersections.length;

                    return element;
                })
            );

            setPreparing(false);
        }
    }, [shouldPrint, setData, _data, selectedAmenities]);

    useEffect(() => {

        setShouldPrint(false);
    }, [_data, selectedAmenities]);

    if (shouldPrint) {
        return (
            <CSVLink
                data={ data }
                filename={`${propertyName }_${ dayjs().format('MM/DD/YYYY HH:mm:ss')}`}
                target='_blank'
            >
                <Button size='small' variant='contained' disabled={preparing}>

                    Download CSV

                </Button>
            </CSVLink>
        );
    }

    return (

        <Button size='small' variant='contained' onClick={() => setShouldPrint(true)}>
            Prepare CSV
        </Button>
    );
};
export default PrintCsv;
;
